/*
 * Bold Upsell AJAX bridge
 * ------------------------
 * This theme adds to cart over AJAX (product-form.js calls evt.preventDefault()
 * and fetches /cart/add.js), so Bold Upsell never sees a real add-to-cart and
 * its popup never triggers. Per Bold's AJAX-cart install guide, the theme must
 * emit Bold's events after the cart is rebuilt. We hook the theme's own
 * pub/sub "cart-update" event (published by product-form.js on a successful add)
 * and forward it to Bold's event emitter.
 * Guide: https://support.boldcommerce.com/boldupsell/bold-upsell-legacy/installation-guide-for-bold-upsell
 */
(function () {
  function boldReady() {
    return (
      typeof BOLD === 'object' &&
      BOLD.common &&
      BOLD.common.eventEmitter &&
      typeof BOLD.common.eventEmitter.emit === 'function'
    );
  }

  function notifyBold(isAddToCart) {
    if (!boldReady()) return;
    BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
    // Only pop the upsell modal on an actual add-to-cart, not on quantity edits.
    if (isAddToCart) {
      BOLD.common.eventEmitter.emit('BOLD_COMMON_redirect_upsell_product');
    }
  }

  function bindCartUpdate() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      return false;
    }
    // Sources that represent a real add-to-cart (vs. 'cart-items' quantity edits).
    const ADD_SOURCES = ['product-form', 'quick-add'];
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const isAddToCart = !!event && ADD_SOURCES.indexOf(event.source) !== -1;
      notifyBold(isAddToCart);
    });
    return true;
  }

  // subscribe()/PUB_SUB_EVENTS come from pubsub.js/constants.js; retry briefly
  // in case this script executes before they are defined.
  if (!bindCartUpdate()) {
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (bindCartUpdate() || attempts >= 40) clearInterval(timer);
    }, 100);
  }
})();
